export default __webpack_public_path__ + "static/media/limb_cube@2x.6edb8819.webp";